import firebase, { app } from "firebase";
import firebaseConfig from "../projectConfig";

export default class Project {
  private static _project: app.App = firebase.initializeApp(firebaseConfig);
  public static readonly Instance: app.App = Project._project;
}
